var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4C18.5 3.17157 17.8284 2.5 17 2.5C16.1716 2.5 15.5 3.17157 15.5 4H18.5ZM15.5 36C15.5 36.8284 16.1716 37.5 17 37.5C17.8284 37.5 18.5 36.8284 18.5 36H15.5ZM10 5.5H30V2.5H10V5.5ZM34.5 10V30H37.5V10H34.5ZM30 34.5H10V37.5H30V34.5ZM5.5 30V10H2.5V30H5.5ZM10 34.5C7.51472 34.5 5.5 32.4853 5.5 30H2.5C2.5 34.1421 5.85786 37.5 10 37.5V34.5ZM34.5 30C34.5 32.4853 32.4853 34.5 30 34.5V37.5C34.1421 37.5 37.5 34.1421 37.5 30H34.5ZM30 5.5C32.4853 5.5 34.5 7.51472 34.5 10H37.5C37.5 5.85786 34.1421 2.5 30 2.5V5.5ZM10 2.5C5.85786 2.5 2.5 5.85786 2.5 10H5.5C5.5 7.51472 7.51472 5.5 10 5.5V2.5ZM15.5 4V36H18.5V4H15.5ZM17 21.5H35V18.5H17V21.5Z",
    fill: "#01C37D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/Status.023a7b8543438fd86a42f61831563ce1.svg";
export { ForwardRef as ReactComponent };